export default "__VITE_ASSET__WoHuz6t3__"